import { render, staticRenderFns } from "./wxLogsList.vue?vue&type=template&id=45145706"
import script from "./wxLogsList.vue?vue&type=script&lang=js"
export * from "./wxLogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports